import { Heading } from "@wexinc/wex-ui";
import useCopPortalAppService from "services/portal-app";
import { BasicCard, FeaturedCard } from "./components/AppCard";

const Hub: React.FC = () => {
  const portalAppService = useCopPortalAppService();
  const myApps = portalAppService.getPortalApps();
  const featuredApp = myApps.find((i) => i.isFeatured);

  return (
    <div className="overflow-auto h-full bg-neutral-dark-5 pt-28 w-full">
      <div className="w-5/6 mx-auto">
        <div className="mx-auto max-w-[960px]">
          {featuredApp && <FeaturedCard app={featuredApp} />}
          <Heading
            size="small"
            className="font-semibold pt-10 pb-4 ml-3"
          >
            My apps
          </Heading>
          <div className="grid grid-cols-auto-304 justify-items-center gap-6 pb-10">
            {myApps?.map((i) => {
              return i.url !== "#" && (
                <BasicCard
                  app={i}
                  key={i.id}
                />
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Hub;